/* jshint esversion: 6 */
/**
 * SPDX-FileCopyrightText: 2024 Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { getLoggerBuilder } from '@nextcloud/logger'

const Logger = getLoggerBuilder()
	.setApp('polls')
	.detectUser()
	.build()

export { Logger }
